<template>
    <div class="container">
        <div class="cont">
            <img
                    src="../../assets/img/coupons2.jpg"
                    style="width: 100%"
                    class="img"
                    alt=""
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "coupons1"
    }
</script>

<style scoped>
    .container {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        margin: 0 auto;
        max-width: 500px;
        height: 100vh;
        background: rgb(255,43,73);
        /* background-image: linear-gradient(#fff1e0, #ff9940, #ffbe5c, #ffedd2); */
    }
    .cont {
        margin: 0 auto;
    }
    .img {
        width: 100%;
    }
</style>
